import React from "react";
import image from "../assets/image.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

function Section1({ section }) {
  const [text, textInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const [img, imageInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariantsText = {
    hidden: {
      opacity: 0,
      x: -50,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  const animationVariantsImage = {
    hidden: {
      opacity: 0,
      x: 50,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <div className="section1" ref={section}>
      <motion.div
        className="section1-text"
        
        initial="hidden"
        animate={textInView ? "visible" : "hidden"}
        variants={animationVariantsText}
      >
        <div ref={text}>Hey, i’m a</div>
        <div>
          <span className="highlighted">web</span> and{" "}
          <span className="highlighted">mobile</span>
        </div>
        <div>
          developer{" "}
          <span
            style={{ color: "#0CA4E7", fontSize: "5rem", lineHeight: " 0rem" }}
          >
            .
          </span>
        </div> 
        <div className="description">
          My principle is that good work , sincerity and discipline are the
          foundation of everything that's why with me you won't have to worry
          because you can be sure that your needs will be met.
        </div>
        <Link
          className="button"
          to="https://www.linkedin.com/in/ala-gtari-869265214/"
          target="_blank"
        >
          Hire me
        </Link>
      </motion.div>
      <motion.img
        src={image}
        ref={img}
        initial="hidden"
        animate={imageInView ? "visible" : "hidden"}
        variants={animationVariantsImage}
      />
    </div>
  );
}

export default Section1;
